<template>
  <div>
    <div
      id="csat"
      :class="`card px-${space} py-${space} mt-${space} wrapper-csat`"
      v-if="items.length > 0 && items[0].total > 0 && !loader"
    >
      <div class="col-12" style="display: flex; padding: 0px; max-height: 45px">
        <div class="col-10" style="padding: 0px">
          <button
            class="btn col-6 text-left"
            style="box-shadow: none"
            @click="visible = !visible"
            :class="isPanel ? 'font-size-title' : ''"
          >
            <i class="fas fa-heart"></i>
            {{ this.$t('reports.csat.csatLabelReport') }}
          </button>
        </div>

        <div class="col-2" style="padding: 0px">
          <div v-if="!isPanel" class="pull-right" style="display: flex">
            <div class="custom-switch" style="padding-left: 35px">
              <div class="col-12">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="switch-top2-csat"
                  v-model="top2Selected"
                />
                <label class="custom-control-label" for="switch-top2-csat">
                  Top 2 box score
                </label>
              </div>
            </div>

            <button
              class="btn pull-right"
              style="box-shadow: none"
              @click="visible = !visible"
            >
              <i class="fas fa-angle-double-right" v-if="!visible"></i>
              <i v-else class="fas fa-angle-double-down"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="wrapper-rankings card" v-if="loader">
        <div>
          <!-- <div class="loader d-flex justify-content-center align-items-center">
          <b-spinner
            variant="primary"
            type="grow"
            :label="`${this.$t('reports.loadingLabel')}...`"
          ></b-spinner>
        </div> -->

          <b-table
            :fields="fields"
            :items="[0, 1, 2, 3]"
            caption-bottom
            sort-icon-left
          >
            <template v-slot:cell(question)>
              <div>
                <idx-skeleton width="80" height="15" radius="10" />
              </div>
            </template>
            <template v-slot:cell(progress)>
              <div class="mt-2">
                <idx-skeleton width="50" height="15" radius="10" />
              </div>
            </template>
            <template v-slot:cell(score)>
              <div class="text-right">
                <idx-skeleton width="25" height="15" radius="10" />
              </div>
            </template>
            <template v-slot:cell(total)>
              <div class="text-center">
                <idx-skeleton width="25" height="15" radius="10" />
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div v-else>
        <b-collapse v-model="visible" class="mt-2">
          <b-table
            :id="isPanel ? 'size-panels' : ''"
            :fields="fields"
            :items="items"
            caption-bottom
            sort-icon-left
          >
            <template v-slot:cell(progress)="row">
              <div
                v-if="row.item.type !== 'total'"
                class="mt-2"
                :style="`font-size: ${fontSize}px;`"
              >
                <b-progress
                  :value="calculateScore(row.item.progress)"
                  :max="10"
                ></b-progress>
              </div>
            </template>
            <template v-slot:cell(score)="row">
              <div
                v-if="row.item.type !== 'total'"
                class="text-right"
                :style="`font-size: ${fontSize}px;`"
              >
                {{ showScore(row.item.score) }}
              </div>
            </template>
            <template v-slot:cell(total)="row">
              <div class="text-center" :style="`font-size: ${fontSize}px;`">
                {{ row.item.total }}
              </div>
            </template>
            <!-- <template v-slot:table-caption>
            <div class="text-right px-3">
              Total de respostas válidas: {{ total }}
            </div>
          </template> -->
          </b-table>
          <div v-if="!isPanel" class="row">
            <div class="col-12 mt-2 text-right">
              <a
                @click="exportToXLS"
                :title="`${this.$t('reports.exportXlsLabel')}`"
              >
                <span class="xls">
                  <i class="fas fa-file-download"></i>
                </span>
              </a>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
    <div v-if="!loader && items.length === 0">
      <span>Sem dados para exibir.</span>
    </div>
    <div v-if="loader">
      <b-table
        :fields="fields"
        :items="[0, 1, 2, 3]"
        caption-bottom
        sort-icon-left
        id="size-panels"
      >
        <template v-slot:cell(question)>
          <div>
            <idx-skeleton width="80" height="15" radius="10" />
          </div>
        </template>
        <template v-slot:cell(progress)>
          <div class="mt-2">
            <idx-skeleton width="50" height="15" radius="10" />
          </div>
        </template>
        <template v-slot:cell(score)>
          <div class="text-right">
            <idx-skeleton width="25" height="15" radius="10" />
          </div>
        </template>
        <template v-slot:cell(total)>
          <div class="text-center">
            <idx-skeleton width="25" height="15" radius="10" />
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import XLSX from 'xlsx';
import EmptyState from '@/components/molecules/empty-state';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import api from '@/services/api';
import EventBus from '../../../../../../../eventBus';

export default {
  name: 'ScoreCsat',

  props: ['showCollapsed', 'dataGraph'],

  components: {
    EmptyState,
    idxSkeleton,
  },

  data: () => ({
    isBusy: false,
    empty: false,
    filter: null,
    userAuth: null,
    visible: true,
    total: 0,
    page: 1,
    limit: 10,
    items: [],
    csatData: [],
    loader: false,
    fields: [],
    totalAnswers: 0,
    lang: 'br',
    top2Selected: false,
    isPanel: false,
    space: 2,
    fontSize: 16,
  }),

  watch: {
    actionGroupData: function watchActionGroupData() {
      this.mountCsat();
    },
    myActionId: function watchMyActionId() {
      this.mountCsat();
    },
    myIh1: function watchMyIh1() {
      this.mountCsat();
    },
    myIh2: function watchMyIh2() {
      this.mountCsat();
    },
    calendarDates: function watchDates() {
      this.mountCsat();
    },
    myMetric: function watchMyMetric() {
      this.mountCsat();
    },
    'indicatorData.value': function watchMyMetric() {
      this.mountCsat();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.mountCsat();
    },
    '$i18n.locale': function watchLocale(value) {
      this.lang = value;
      this.mountCsat();
    },
    top2Selected: function watchTop2Selected() {
      this.mountCsat();
    },
  },

  computed: {
    ...mapState('charts', ['filterRankings']),
    ...mapState('actions', ['myActionId', 'actionGroupData']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  methods: {
    async mountCsat() {
      this.loader = true;
      const response = await api.get(`reports/get-ranking-generic-panel`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          filter: this.filterRankings ? this.filterRankings : null,
          companyId: this.userAuth.companyId,
          actionId: this.myActionId !== '0' ? this.myActionId : null,
          // startDate: this.calendarDates.start ? this.calendarDates.start : null,
          // endDate: this.calendarDates.end ? this.calendarDates.end : null,
          period: data.period ? data.period : null,
          ih1: this.myIh1.map((item) => item._id),
          ih2: this.myIh2 === '0' ? null : this.myIh2,
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          lang: this.lang,
          isTop2: this.top2Selected,
          reportType: 'CSAT',
          _id: this.dataGraph._id,
        },
      });
      this.csatData = response.data;
      this.items = [];
      this.csatData.map((obj) => {
        // let grades = 0;

        // obj.grades.map((item) => {
        //   grades = item + grades;
        // });
        if (obj.question.toLowerCase() === 'total') {
          this.items.push({
            question: this.$t('reports.csat.totalAnswersLabel'),
            type: 'total',
            total: obj.total,
          });
          this.totalAnswers = obj.total;
          this.total = obj.total;
        } else {
          this.items.push({
            question: obj.question,
            progress: obj.average,
            score: obj.average,
            total: obj.total,
          });
        }

        this.isBusy = false;
      });

      this.loader = false;
    },

    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },

    exportToXLS() {
      const header = [
        this.$t('reports.csat.addQuestionLabel'),
        this.$t('reports.csat.scoreLabel'),
        this.$t('reports.csat.totalLabel'),
      ];

      const arr = [];

      this.items.forEach((el) => {
        arr.push({
          [this.$t('reports.csat.addQuestionLabel')]: el.question,
          [this.$t('reports.csat.scoreLabel')]: el.score,
          [this.$t('reports.csat.totalLabel')]: el.total,
        });
      });

      const wb = XLSX.utils.book_new();
      wb.SheetNames.push('rankings-1-10');

      const ws = XLSX.utils.json_to_sheet(arr, { header });
      wb.Sheets['rankings-1-10'] = ws;

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'rankings-1-10.xlsx');
      document.body.appendChild(link);
      link.click();
    },
    calculateScore(score) {
      if (this.top2Selected) {
        return parseFloat((score / 10).toFixed(2));
      }
      return score;
    },
    showScore(score) {
      if (this.top2Selected) {
        return `${score}%`;
      }
      return score;
    },

    async mountCardPanel(data) {
      this.loader = true;
      const response = await api.get(`reports/get-ranking-generic-panel`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          filter: null,
          companyId: this.userAuth.companyId,
          actionId: data.actionId ? data.actionId._id : null,
          // startDate: '2022-01-01',
          // endDate: '2022-07-08',
          ih1:
            data.ih1 && data.ih1.length > 0
              ? data.ih1.map((item) => item._id)
              : null,
          period: data.period ? data.period : null,
          metric: data.metric ? data.metric : null,
          groupId: data.actionGroupId ? data.actionGroupId._id : null,
          indicator: data.indicator ? data.indicator : null,
          indicatorValue: data.valueIndicator ? data.valueIndicator : null,
          // indicatorRange: this.indicatorData.range,
          reportType: 'CSAT',
          lang: this.lang,
          isTop2: this.top2Selected,
          _id: this.dataGraph._id,
        },
      });

      this.csatData = response.data;
      this.items = [];
      this.csatData.map((obj) => {
        const grades = 0;

        /* obj.grades.map((item) => {
          grades = item + grades;
        }); */
        if (obj.question.toLowerCase() === 'total') {
          this.items.push({
            question: this.$t('reports.csat.totalAnswersLabel'),
            type: 'total',
            total: obj.total,
          });
          this.totalAnswers = obj.total;
          this.total = obj.total;
        } else {
          this.items.push({
            question: obj.question,
            progress: obj.average,
            score: obj.average,
            total: obj.total,
          });
        }

        this.isBusy = false;
      });

      this.loader = false;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.fields = [
      {
        key: 'question',
        label: this.$t('reports.csat.addQuestionLabel'),
        sortable: true,
        class: 'questionTh',
      },
      { key: 'progress', class: 'progressTh' },
      {
        key: 'score',
        label: this.$t('reports.csat.scoreLabel'),
        sortable: true,
        class: 'scoreTh',
      },
      {
        key: 'total',
        label: this.$t('reports.csat.totalLabel'),
        sortable: true,
        class: 'totalTh',
      },
    ];
  },

  mounted() {
    this.visible = !this.showCollapsed;
    this.lang = this.$i18n.locale;

    if (this.$route.fullPath.indexOf('panels') !== -1) {
      this.isPanel = true;
      this.mountCardPanel(this.dataGraph);

      EventBus.$on('update-csat', (items) => {
        this.mountCardPanel(items);
      });

      this.space = 0;
    } else {
      this.mountCsat();
      this.isPanel = false;
      EventBus.$on('filter-rankings', () => {
        this.mountCsat();
      });

      this.space = 2;
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/themes/default/variables.scss';

.no-padding {
  padding: 0;
}
.table {
  margin: 0;
}
.wrapper-csat .table > thead > tr:nth-child(2) {
  display: none;
}
.wrapper-csat .btn .btn-light .collapsed {
  background-color: transparent;
}
.wrapper-rankings.card {
  min-height: 200px;
}
.wrapper-rankings .loader {
  min-height: 200px;
}
.card {
  border: 1px solid #fff;
}
.card-panel {
  border: 1px solid #fff;
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;

  transition: color 0.2s;

  &:hover {
    color: #1dc86e;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/rankings/components/panels/csat.vue